/**
 * Phone OTP send — server-side only via send-phone-otp Edge Function.
 * Msegat credentials must live in Supabase secrets (MSEGAT_API_KEY, etc.).
 */

const CONNECTION_ERROR_MSG =
  'تعذر الاتصال بخدمة إرسال الرمز. تحقق من الاتصال وأعد المحاولة.';

/**
 * Normalize Saudi mobile to E.164 (+966xxxxxxxxx).
 */
export function normalizePhone(phone) {
  if (!phone || typeof phone !== 'string') return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('9665') && digits.length === 12) return `+${digits}`;
  if (digits.startsWith('05') && digits.length === 10) return '+966' + digits.slice(1);
  if (digits.startsWith('5') && digits.length === 9) return '+966' + digits;
  return '';
}

async function callSendPhoneOtp(phone) {
  const url = import.meta.env?.VITE_SUPABASE_URL;
  const anonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error(CONNECTION_ERROR_MSG);
  }

  const functionUrl = `${url.replace(/\/$/, '')}/functions/v1/send-phone-otp`;
  const res = await fetch(functionUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${anonKey}`,
      'Content-Type': 'application/json',
      apikey: anonKey,
    },
    body: JSON.stringify({ phone }),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(CONNECTION_ERROR_MSG);
  }

  if (!res.ok) {
    throw new Error(data?.error || data?.message || 'فشل إرسال رمز التحقق');
  }

  return data;
}

/**
 * Send OTP via Edge Function (Msegat on server).
 * @returns {Promise<{ success: boolean, id?: number|string, error?: string }>}
 */
export async function sendOTP(phone) {
  const normalized = normalizePhone(phone);
  if (!normalized) {
    return { success: false, error: 'رقم الجوال غير صالح' };
  }

  try {
    const data = await callSendPhoneOtp(normalized);
    if (data?.success && data?.id != null) {
      return { success: true, id: data.id };
    }
    return { success: false, error: data?.error || 'فشل إرسال رمز التحقق' };
  } catch (err) {
    if (err.message === CONNECTION_ERROR_MSG || err.name === 'TypeError') {
      await new Promise((r) => setTimeout(r, 1500));
      try {
        const data = await callSendPhoneOtp(normalized);
        if (data?.success && data?.id != null) {
          return { success: true, id: data.id };
        }
        return { success: false, error: data?.error || 'فشل إرسال رمز التحقق' };
      } catch (retryErr) {
        return {
          success: false,
          error: retryErr.message || CONNECTION_ERROR_MSG,
        };
      }
    }
    return { success: false, error: err.message || 'فشل إرسال رمز التحقق' };
  }
}
